module.exports = __webpack_public_path__ + "img/Group-32707-1-1.f8572bd4.png";